var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Icon", {
    attrs: { icon: _vm.icon, width: _vm.size === "small" ? 16 : 32 }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }